import React from 'react';
import { i18n as I18n } from 'utils/i18n';
import Textbox from '../../textbox';

const CountyField = ({ error, ...props }) => {
  return (
    <Textbox
      label={I18n.t('registration.company_details.fields.county.label')}
      name="county"
      placeholder={I18n.t('registration.company_details.fields.county.label')}
      error={!!error}
      errorMsg={error}
      className="input--county"
      {...props}
    />
  );
};

export default CountyField;
